// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".google-analytics-cookies-iframe[data-v-5aa9fa4e]{width:0;height:0;visibility:hidden;position:absolute;right:-5000px}", ""]);
// Exports
module.exports = exports;
